/** @format */

import {styled} from '@mui/material/styles';
import {Link} from 'react-router-dom';

import {text} from 'ui';

/**
 * Возврат в архив — переход, а не действие, поэтому ссылка, а не кнопка.
 * Кнопка внутри `<a>` дала бы интерактивный элемент внутри интерактивного.
 */
export const BackLink = styled(Link)(({theme}) => ({
  ...text('label.l'),
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {textDecoration: 'underline'},
}));
